import { useState } from "react";

export default function CompaniesPage({ companies, addCompany, deleteCompany }) {
  const [companyName, setCompanyName] = useState("");
  const [adminName, setAdminName] = useState("");
  const [adminUsername, setAdminUsername] = useState("");
  const [adminPassword, setAdminPassword] = useState("");

  const createCompany = () => {
    if (!companyName.trim() || !adminName.trim() || !adminUsername.trim() || !adminPassword.trim()) {
      return;
    }

    addCompany({
      company_name: companyName.trim(),
      admin_name: adminName.trim(),
      admin_username: adminUsername.trim(),
      admin_password: adminPassword
    });
    setCompanyName("");
    setAdminName("");
    setAdminUsername("");
    setAdminPassword("");
  };

  return (
    <div>
      <h1>Компании</h1>

      <div className="company-create">
        <input
          value={companyName}
          onChange={(event) => setCompanyName(event.target.value)}
          placeholder="Название компании"
        />

        <input
          value={adminName}
          onChange={(event) => setAdminName(event.target.value)}
          placeholder="Имя Админа"
        />

        <input
          value={adminUsername}
          onChange={(event) => setAdminUsername(event.target.value)}
          placeholder="Username Админа"
        />

        <input
          value={adminPassword}
          onChange={(event) => setAdminPassword(event.target.value)}
          placeholder="Временный пароль"
          type="password"
        />

        <button onClick={createCompany}>Создать компанию</button>
      </div>

      <div className="company-list">
        {companies.map((company) => (
          <div className="company-row" key={company.id}>
            <div>
              <strong>{company.name}</strong>
              <span>{company.status === "active" ? "Активна" : company.status}</span>
              <span>Админ: {company.admin_username || "не назначен"}</span>
            </div>
            <span>{company.users_count} пользователей</span>
            <span>{company.payments_count} платежей</span>
            <button
              className="company-delete-btn"
              onClick={() => {
                if (window.confirm(`Удалить компанию ${company.name}?`)) {
                  deleteCompany(company.id);
                }
              }}
              title="Удалить компанию"
              aria-label={`Удалить компанию ${company.name}`}
            >
              &#128465;
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
